import SodService from "./sod-service";

class UsersService extends SodService {
    async signIn(username, password) {
        const data = await this.post("/auth/token", { username, password }, {}, false);
        return data;
    }

    async getCurrentUser() {
        const data = await this.get("/core/auth/user");
        return this.parseCurrentUser(data);
    }

    async getSodActions() {
        const data = await this.get("/sod/user-actions", {}, true, false);
        return this.parseActions(data);
    }

    async getUserRoles() {
        const data = await this.get("/core/auth/user-groups");
        const userRoles = data.map((userRole) => this.parseUserRole(userRole));
        return userRoles;
    }

    async getUsers(params) {
        const config = this.generateConfigForGetEntities(params);

        const data = await this.get("/core/auth/users", config);

        const users = data?.rows.map((user) => this.parseUser(user)) || [];
        const total = data?.total;

        return { users, total };
    }

    async getUsersForSearchHelp(params, signal) {
        const config = this.generateConfigForGetEntities(params, signal);

        const data = await this.get("/core/auth/users", config);

        const rows = data && data.rows.map((item) => this.parseUserForSearchHelp(item));
        const total = data && data.total;

        return { rows, total };
    }

    async getUsersFilters(params) {
        return this.getFilters("/core/auth/users/filters", params);
    }

    async getUserDetailed(username) {
        const data = await this.get(`/core/auth/user-detailed/${username}`);
        return this.praseUserDetailed(data);
    }

    async createUser(user) {
        const data = await this.post(`/core/auth/user-detailed/${user.username}`, this.parseUserToServer(user));
        return this.praseUserDetailed(data);
    }

    async editUser(user) {
        const data = await this.put(`/core/auth/user-detailed/${user.username}`, this.parseUserToServer(user));
        return this.praseUserDetailed(data);
    }

    async changeUserPassword(username, password) {
        const data = await this.post(`/core/auth/user/change-password`, { username, password });
        return data;
    }

    async changeUserPasswordInProfile(password) {
        const data = await this.post("/core/auth/user/change-password-in-profile", { password });
        return data;
    }

    async getUserAgreementText() {
        const data = await this.get("/core/auth/user-agreement");
        return data;
    }

    async acceptUserAgreement() {
        const data = await this.post("/core/auth/user-agreement");
        return data;
    }

    async lockUser(username, lock = false) {
        const data = await this.post(`/core/auth/user-detailed/lock`, { username, action: lock ? "lock" : "unlock" });
        return data;
    }

    async deleteUser(username) {
        return this.delete(`/core/auth/user-detailed/${username}`);
    }

    async getUsersColumns() {
        return await this.getColumns("/core/auth/users/columns");
    }

    async getUserChangeHistory(key) {
        const data = await this.get(`/core/auth/user-detailed/change-history/${key}`);
        return data && data.map((item) => this.parseUserActionLog(item));
    }

    parseUser(user) {
        return {
            username: user.username,
            firstName: user.first_name,
            lastName: user.last_name,
            middleName: user.middle_name,
            role: user.role,
            phone: user.phone,
            email: user.email,
            dateJoined: user.date_joined,
        };
    }

    parseUserForSearchHelp(user) {
        return {
            key: user.username,
            text: `${user.first_name} ${user.last_name}`,
        };
    }

    praseUserDetailed(user) {
        return {
            username: user.username,
            firstName: user.first_name,
            lastName: user.last_name,
            middleName: user.middle_name,
            role: user.role,
            phone: user.phone,
            email: user.email,
            dateJoined: user.date_joined,
            password: user.password,
            locked: user.is_locked,
            approvalGroup: user.approval_group,
            integrationId: user.integration_id
        };
    }

    parseUserToServer(user) {
        return {
            username: user.username,
            first_name: user.firstName,
            last_name: user.lastName,
            middle_name: user.middleName,
            role: user.role,
            phone: user.phone,
            email: user.email,
            date_joined: user.dateJoined,
            password: user.password,
            approval_group: user.approvalGroup,
            integration_id: user.integrationId
        };
    }

    parseUserRole(userRole) {
        return {
            id: userRole.group_id,
            name: userRole.name,
        };
    }

    parseCurrentUser(user) {
        return {
            username: user.username,
            firstName: user.first_name,
            lastName: user.last_name,
            middleName: user.middle_name,
            email: user.email,
            phone: user.phone,
            role: user.role,
            canResetIntegrationStatus: user.can_reset_integration_status,
            actions: user.actions.map(this.parseAction),
            screenButtons: user.screen_buttons?.map(this.parseAction),
            shouldChangePassword: user.should_change_password,
            acceptedUserAgreement: user.accepted_user_agreement,
        };
    }

    parseActions(actions) {
        return {
            screenButtons: actions.screen_buttons?.map(this.parseAction),
            actions: actions.menu_buttons?.map(this.parseAction),
        };
    }

    parseAction(action) {
        return {
            id: action.action_id,
            type: action.action_type,
            title: action.title,
        };
    }
}

const usersService = new UsersService();

export { usersService };
export default UsersService;
